import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class DashboardLaneActionableItemModel extends BaseModel {
  static urlPath = "dashboard_lanes";

  @attr("number") id;
  @attr("string") name;
  @attr("string") actingUserName;
  @attr("string") clientName;
  @attr("string") lawFirmName;
  @attr("number") clientCount;
  @attr("string") relativeDueDate;
  @attr("string") shortDescription;
  @attr("string") accidentDate;
  @attr("string") dueDate;
  @attr("number") formCount;
  @attr("string") formUrl;
  @attr("string") priority;
  @attr("string") priorityDate;
  @attr("string") status;
  @attr("string") completedAt;
  @attr("string") completedByName;
  @attr("number") onCaseId;
  @attr("number") onFirmId;
  @attr("number") onProviderId;
  @attr("string") onCaseName;
  @attr("string") onProviderName;
  @attr("string") onLawfirmName;
}
